<ng-container [ngSwitch]="linkType">
    <div
        elementObserverDirective
        [observeType]="'promotion'"
        [observeLink]="link"
        *ngSwitchCase="'menu'"
        (click)="openLink($event)"
        [attr.class]="styleClass"
        [attr.data-title]="dataTitle"
    >
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>

    <div
        elementObserverDirective
        [observeType]="'promotion'"
        [observeLink]="link"
        *ngSwitchCase="'product'"
        (click)="openLink($event)"
        [attr.class]="styleClass"
        [attr.data-title]="dataTitle"
    >
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>

    <a
        elementObserverDirective
        [observeType]="'promotion'"
        [observeLink]="link"
        *ngSwitchDefault
        (click)="openLink($event)"
        [attr.href]="configUrl$ | async"
        [attr.class]="styleClass"
        [attr.aria-label]="ariaLabel"
        [attr.data-title]="dataTitle"
    >
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
</ng-container>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
